import React, {useEffect} from 'react';
import Header from '../../components/header/Header';
import ContactForm from '../../components/body/ContactForm';
import './contact.css';
import Footer from '../../components/footer/Footer';


function Contact() {

  useEffect(() => {
    document.title = 'CONTACT | NOVAZON RELAY';
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
                  <Header />
                  <ContactForm page={"contact"}/>
                  <Footer />
            </>
  )
}

export default Contact